export default __webpack_public_path__ + "static/media/Jose-Valdimir-Filho.2fb45d17.png";